<template>
	<div class="panel-view">
		<slot />
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.panel-view {
		& > * {
			margin-bottom: 	20px;
			padding-bottom: 20px;
			border-bottom: 	1px solid rgb(233, 233, 233);

			&:last-child {
				margin-bottom: 	0;
				padding-bottom: 0;
				border-bottom: 	none;
			}
		}
	}
</style>